import { render, staticRenderFns } from "./alertFornitore.vue?vue&type=template&id=0e489678"
import script from "./alertFornitore.vue?vue&type=script&lang=js"
export * from "./alertFornitore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports